import React from 'react'

import {
  LuCalendar,
  LuCheckSquare,
  LuChevronDown,
  LuCircleDollarSign,
  LuHash,
  LuList,
  LuListChecks,
  LuListOrdered,
  LuType,
} from 'react-icons/lu'

import type { EntityExtendedJsonSchemaFieldType } from '@/types/library/ExtendedSchema'

export const TYPE_ICON_MAP: Record<
  EntityExtendedJsonSchemaFieldType,
  React.ReactNode
> = {
  string: <LuType size={15} className="flex-shrink-0" />,
  number: <LuHash size={15} className="flex-shrink-0" />,
  boolean: <LuCheckSquare size={15} className="flex-shrink-0" />,
  date: <LuCalendar size={15} className="flex-shrink-0" />,
  currency: <LuCircleDollarSign size={15} className="flex-shrink-0" />,
  dropdown: <LuChevronDown size={15} className="flex-shrink-0" />,
  multi_select: <LuListChecks size={15} className="flex-shrink-0" />,
  string_list: <LuList size={15} className="flex-shrink-0" />,
  number_list: <LuListOrdered size={15} className="flex-shrink-0" />,
}
